/**
 * A custom hook to be able to save and read cookies.
 * @returns {Object[]}
 */
const useCookies = () => {
    const saveToCookie = (cookieName, cookieValue) => {
        document.cookie = `${cookieName}=${cookieValue}`;
    };

    const readCookie = (cookieName) => {
        const cookies = document.cookie.split(';');
        let cookieValue = '';
        cookies.forEach((cookie) => {
            if (cookie.startsWith(`${cookieName}=`)) {
                cookieValue = cookie.replace(`${cookieName}=`, '');
            }
        });
        return cookieValue;
    };
    return [saveToCookie, readCookie];
};

export default useCookies;
